<span>
    <span class="flag-icon" [ngClass]="'flag-icon-'+item.codePays.toLowerCase()" *ngIf="item.codePays"></span>
    <span class="m-l-10">{{ options.displayItem(item) }}</span>
</span>